import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { mapWeatherIconStoreModelToViewModel, weatherIconAssets } from '@domain/weather/weather-icon.mappings';
import { WeatherIconStoreModelEnum } from '@domain/weather/weather.enums';

@Component({
  selector: 'app-weather-display',
  imports: [SvgIconComponent, TranslatePipe, DecimalPipe],
  templateUrl: './weather-display.component.html',
  host: { class: 'flex items-center' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeatherDisplayComponent {
  public icon = input<WeatherIconStoreModelEnum | null>();
  public temperatureCelsius = input<number | null>();
  public details = input(false);
  public iconSize = input('20');

  public readonly weatherIcon = computed(() => {
    const icon = this.icon();
    return icon ? mapWeatherIconStoreModelToViewModel(icon) : undefined;
  });

  constructor() {
    injectRegisterIcons(weatherIconAssets);
  }
}
